export default {
  id: "page6",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",
  show: "parseInt(values.ankieta_ciastaMixCz)<6",
  questions: [
    {
      type: "justlabel",
      number: "20",
      label:
        "Jakie rodzaje <span class='has-text-danger'>ciast z torebki / kartonu</span> Pan(i) przygotowuje?",
      info:
        "Dla każdego rodzaju ciasta proszę zaznaczyć jedną odpowiedź TAK lub NIE."
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      labelWidth: "is-three-fifths",
      topLine: true,
      bottomLine: true
    },
    {
      label: "Babka  / ciasto ucierane - jak babki piaskowe, cytrynowe itp.",
      type: "radio",
      id: "kategoria2_babkaMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Murzynek, ciasto czekoladowe",
      type: "radio",
      id: "kategoria2_murzynekMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Biszkopt / ciasto na bazie biszkoptu",
      type: "radio",
      id: "kategoria2_biszkoptMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Wypieki na bazie ciasta kruchego (ciasta, ciasteczka, babeczki, jabłecznik na kruchym cieście z torebki)",
      type: "radio",
      id: "kategoria2_kruchaBazaMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Babeczki z ciasta „babkowego”, muffinki",
      type: "radio",
      id: "kategoria2_muffinkiMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Ciasto przekładane masami, kremami, bitą śmietaną (typu Kopiec Kreta, Krówka, Wuzetka itp.)",
      type: "radio",
      id: "kategoria2_ciastoKremMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Karpatka/ Ciasto i krem do Karpatki",
      type: "radio",
      id: "kategoria2_ciastoKarpatkaMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Sernik pieczony",
      type: "radio",
      id: "kategoria2_sernikPieczonyMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Piernik",
      type: "radio",
      id: "kategoria2_piernikMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Sernik lub inne ciasta na zimno",
      type: "radio",
      id: "kategoria2_sernikZimnyMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ciasto drożdżowe",
      type: "radio",
      id: "kategoria2_drozdzoweMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Pierniczki",
      type: "radio",
      id: "kategoria2_pierniczkiMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Bezy",
      type: "radio",
      id: "kategoria2_bezyMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Brownie",
      type: "radio",
      id: "kategoria2_brownieMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Gofry",
      type: "radio",
      id: "kategoria2_gofryMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Pankejki / Pancakes",
      type: "radio",
      id: "kategoria2_pancakesMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Słodkie bułeczki drożdżowe (w tym cynamonki, mini pączki)",
      type: "radio",
      id: "kategoria2_buleczkiDrozdzoweMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ciasteczka (kruche, cookies)",
      type: "radio",
      id: "kategoria2_ciasteczkaMix",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page6.js